// Removing an account from the chart (accounts.remove, gap #17): only one nothing has used goes;
// one with entries, a bill line or a ledger match is archived instead (accounts.update active false)
// and keeps its history in every report. The server says which, and why.

/** The server's refusal of accounts.remove, as the screen reads it. */
export interface Refusal {
  code: string;
  message: string;
  detail?: unknown;
}

/**
 * Whether the refusal offers "Archive it instead": the account has entries, or a bill line or the
 * connected ledger points at it (the server's words end "Archive it instead."). Other refusals (a
 * posting rule, a bank account or rule, a vendor, sub-accounts) need that fixed first: archiving
 * is refused for a posting rule too, and the rest would leave something pointing at an archived
 * account.
 */
export function archiveOffered(e: Refusal): boolean {
  if (e.code !== 'conflict') return false;
  const reason = (e.detail as { reason?: string } | undefined)?.reason;
  return reason === 'has_entries' || /Archive it instead\.$/.test(e.message);
}

export const removeOutcome = (a: { code: string; name: string }) =>
  `${a.code} ${a.name} leaves the chart for good. Only an account nothing has used can go; one with entries is archived instead and keeps its history in every report.`;

export const removedText = (a: { code: string; name: string }) => `${a.code} ${a.name} is removed.`;
export const archivedText = (a: { code: string; name: string }) =>
  `${a.code} ${a.name} is archived: it keeps its history in every report, and nothing new posts to it.`;
